<template>
    <el-table
        v-loading="isLoading"
        :data="data"
        class="row-click ah-el-data-table salary-page-unfixed-table"
        show-summary
        border
        :summary-method="getSummaries"
        @row-click="$event => $emit('row-click', $event)"
    >
        <el-table-column prop="month" label="所屬月份" sortable width="130">
            <template slot-scope="scope">
                <span class="strong"> {{ scope.row.year }} 年 {{ scope.row.month }} 月 </span>
            </template>
        </el-table-column>
        <el-table-column prop="headcount" label="領薪人數" align="right" type="headcount" width="80">
            <template slot-scope="scope">
                <Money :v="scope.row.headcount" />
            </template>
        </el-table-column>
        <el-table-column prop="totaL_AMT" label="非固定薪資（兼職/約聘）" sortable align="right">
            <template slot-scope="scope">
                <Money :v="scope.row.totaL_AMT" />
            </template>
            <template slot-scope="scope">
                <div class="primary-number"><Money :v="scope.row.totaL_AMT" /></div>
                <div class="sub-numbers" v-if="scope.row.totaL_AMT && scope.row.headcount">
                    <div>平均：<Money :v="scope.row.totaL_AMT / scope.row.headcount" round /></div>
                </div>
                <div class="sub-numbers" v-else>
                    <div>-</div>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="withholdingTax" label="代扣稅款" sortable align="right">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.withholdingTax" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <div>
                            {{ scope.row.withholdingTaxPaymentDate | dateFormater("YYYY-MM-dd") }}
                        </div>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="withholding2ndHealth" label="代扣二代健保" sortable align="right">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.withholding2ndHealth" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <div>
                            {{ scope.row.withholding2ndHealthPaymentDate | dateFormater("YYYY-MM-dd") }}
                        </div>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="amt" label="實付薪資" sortable align="right">
            <template slot-scope="scope">
                <div class="primary-number">
                    <Money :v="scope.row.amt" />
                </div>
                <div class="sub-numbers">
                    <el-tooltip class="item" effect="dark" content="付款日期" placement="bottom">
                        <div>
                            {{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}
                        </div>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '總計';
                    return;
                }
                if (column.type === 'date' || column.type === 'headcount') {
                    // 付款日期、人數
                    return;
                }

                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => Number.isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!Number.isNaN(value)) {
                            return prev + curr;
                        }
                        return prev;
                    }, 0);
                    sums[index] += '';
                } else {
                    sums[index] = 'N/A';
                }

                if (index !== 0) {
                    if (!Number.isNaN(sums[index])) {
                        sums[index] = Number.parseInt(sums[index], 10).toLocaleString('en-US');
                    }
                }
            });

            return sums;
        },
    },
};
</script>
<style lang="scss">
.salary-page-unfixed-table {
    .el-table__header-wrapper tbody td,
    .el-table__footer-wrapper tbody td {
        // background-color: #fff;
        // border-top: 1px solid #ccc;
        font-weight: bold;
    }
}
</style>
